<template>
  <v-dialog persistent v-model="open" width="400px">
    <template v-slot:activator="{ attrs }">
      <v-btn text v-bind="attrs" @click.stop.prevent="openSave()">
        <span v-if="custom">Update</span>
        <span v-else>Save</span>
        <v-icon>mdi-content-save-move-outline</v-icon>
      </v-btn>
    </template>
    <v-form ref="form">
      <v-card>
        <v-card-title primary-title> Save Filter </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col :cols="12">
              <v-text-field
                outlined
                dense
                label="Name"
                v-model="newIns.name"
                required
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col :cols="12">
              <v-textarea
                label="Description"
                auto-grow
                outlined
                rows="1"
                row-height="15"
                v-model="newIns.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn outlined small color="primary" @click="save(newIns)">
            <span v-if="custom">Update</span>
            <span v-else>Save</span>
          </v-btn>
          <v-btn outlined text small color="error" @click="close()"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "SaveFilter",
  components: {},
  props: {
    custom: { type: Boolean, required: true },
    name: { type: String },
    description: { type: String },
  },
  data: () => ({
    open: false,
    newIns: {},
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 20) || "Name must be less than 20 characters",
    ],
  }),
  watch: {
    open: {
      immediate: true,
      handler(n) {
        if (n) this.reset();
      },
    },
  },
  methods: {
    reset() {
      if (this.custom) {
        this.newIns = { name: this.name, description: this.description };
        return;
      }
      this.newIns = { name: "", description: "" };
    },
    close() {
      this.open = false;
      this.reset();
    },
    save({ name, description }) {
      let v = this.$refs.form.validate();
      if (!v) return;
      this.$emit("save", { name, description });
      this.close();
    },
    openSave() {
      let lock = !this.$store.getters.isPremiumUser;
      if (lock) {
        this.$root.$subscribe.open();
        return;
      }
      this.open = true;
    },
  },
};
</script>